import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { HttpService } from '../../../services/http/http.service';
import { Router, NavigationEnd } from '@angular/router';
import { SearchService } from 'src/app/services/search/search.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  hideElement;
  buttonSelected;
  showCard;
  adminName;
  adminEmail;
  displayFlag: boolean = false;
  showMoreFlag: boolean = true;
  mcqFlag: boolean = true;
  search: string;
  Search: any;
  urlFlag: boolean = true;

  constructor(private location: Location,
    private httpService: HttpService,
    private router: Router,
    private searchService: SearchService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/admin/campaign') {
          this.hideElement = true;
        } else {
          this.hideElement = false;
        }
      }
    });

  }

  ngOnInit() {
    this.adminEmail = localStorage.getItem('email');
    this.adminName = localStorage.getItem('name');
    console.log(this.router.url);
    if (this.router.url === '/admin/questions') {
      this.buttonSelected = 'questions';
    } else if (this.router.url === '/admin/mcq-settings') {
      this.buttonSelected = 'mcq-settings';
    } else if (this.router.url === '/admin/campaign-settings') {
      this.buttonSelected = 'campaign-settings';
    } else if (this.router.url === '/admin/campaign') {
      this.buttonSelected = 'campaign';
    } else if (this.router.url === '/admin/drive' || this.router.url === '/admin/drive-container') {
      this.buttonSelected = 'drive';
    } else if (this.router.url === '/admin/questions-format') {
      this.buttonSelected = 'questions-format';
    }

    // this.buttonSelected = 'campaign'
  }
  goBack() {
    this.location.back();
  }
  redirectTo() {
    localStorage.clear();
    this.httpService.redirectTo('admin/login')
  }

  selectedButton(selected) {
    this.buttonSelected = selected;
    if (selected === 'campaign') {
      this.router.navigate(['admin/campaign']);
    } else if (selected === 'drive') {
      this.router.navigate(['admin/drive']);
    } else if (selected === 'questions') {
      this.router.navigate(['admin/questions']);
    } else if (selected === 'mcq-settings') {
      this.router.navigate(['admin/mcq-settings']);
    } else if (selected === 'campaign-settings') {
      this.router.navigate(['admin/campaign-settings']);
    }
    else if (selected === 'questions-format') {
      this.router.navigate(['admin/mcq-settings']);
    }
    else if (selected == 'etcorrection') {
      this.router.navigate(['admin/excel-upload']);
    }
  }

  showHideCard() {
    if (this.showCard) {
      this.showCard = false;
    } else {
      this.showCard = true;
    }
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['admin/login']);
  }

  changeSideNavDisplay() {
    this.displayFlag = !this.displayFlag;
  }

  showMore() {
    this.showMoreFlag = !this.showMoreFlag;
    if (!this.mcqFlag) {
      this.mcqFlag = !this.mcqFlag;
    }
  }

  lookUp() {
    this.searchService.changeMessage(this.Search);
  }

  mcqMore() {
    this.mcqFlag = !this.mcqFlag;
  }
}
